import React, {  } from 'react';

import { dateFormatOptions } from '../types';
import { DateTimeFormatInput, DatTimeFormatRuleSet } from './Intl.DateTimeFormat';
import { IntlFunction } from './Intl.Function';

export const DateToLocaleDateString = () => (
	<IntlFunction
		input={DateTimeFormatInput}
		mdnLink="https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toLocaleDateString"
		header="Date.prototype.toLocaleDateString"
		description="Returns a string with a language sensitive representation of the date portion of this date. The new **`locales`** and **`options`** arguments let applications specify the language whose formatting conventions should be used and allow to customize the behavior of the function. In older implementations, which ignore the **`locales`** and **`options`** arguments, the locale used and the form of the string returned are entirely implementation dependent."
		options={dateFormatOptions}
		ruleSet={DatTimeFormatRuleSet}
		template="##input:raw##.toLocaleDateString(##locale##, ##options##)" />
)